import Button from '../../../../components/ui/Button';

/**
 * Invite new team member modal. useForm lives in the parent (Team.jsx);
 * register, handleSubmit, and errors are passed as props — matching the
 * SiteFormModal pattern. validatePassword is passed so the register
 * validation option can reference it without importing from the page.
 */
export default function TeamInviteModal({
  onClose,
  register,
  handleSubmit,
  onSubmit,
  errors,
  inviteMutation,
  validatePassword,
  roleOptions,
}) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal team-invite-modal" onClick={(e) => e.stopPropagation()}>
        <h2>Invite Team Member</h2>
        <form onSubmit={handleSubmit(onSubmit)} className="team-invite-form">
          <div className="form-row">
            <div className="form-group">
              <label>First name</label>
              <input
                type="text"
                {...register('firstName', { required: 'First name is required' })}
                className="form-control team-input-thumb"
                autoComplete="given-name"
              />
              {errors.firstName && <span className="form-error">{errors.firstName.message}</span>}
            </div>
            <div className="form-group">
              <label>Last name</label>
              <input
                type="text"
                {...register('lastName', { required: 'Last name is required' })}
                className="form-control team-input-thumb"
                autoComplete="family-name"
              />
              {errors.lastName && <span className="form-error">{errors.lastName.message}</span>}
            </div>
          </div>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              {...register('email', { required: 'Email is required' })}
              className="form-control team-input-thumb"
              autoComplete="email"
            />
            {errors.email && <span className="form-error">{errors.email.message}</span>}
          </div>
          <div className="form-group">
            <label>Password (min 12 characters)</label>
            <input
              type="password"
              {...register('password', {
                required: 'Password is required',
                minLength: { value: 12, message: 'Password must be at least 12 characters' },
                validate: (value) => validatePassword(value) || true,
              })}
              className="form-control team-input-thumb"
              placeholder="12+ chars, upper, lower, number"
              autoComplete="new-password"
            />
            {errors.password && <span className="form-error">{errors.password.message}</span>}
          </div>
          <div className="form-group">
            <label>Role</label>
            <select
              {...register('role')}
              className="form-control team-input-thumb"
            >
              {roleOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label className="form-check-label" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
              <input type="checkbox" {...register('mustChangePassword')} />
              Require password change on next login
            </label>
          </div>
          <div className="form-actions">
            <Button
              type="button"
              className="team-btn-thumb"
              onClick={onClose}
              disabled={inviteMutation.isLoading}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="primary"
              className="team-btn-thumb"
              disabled={inviteMutation.isLoading}
            >
              {inviteMutation.isLoading ? 'Inviting…' : 'Invite Team Member'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
